import {FC} from 'react';
import {useIsMaxSm} from 'features/auth/ui/AuthorizationSteps/useIsMaxSm';
import {Drawer} from 'shared/ui/Drawer';
import {getWorkStatusesInfoSections, WORK_STATUSES_INFO_TITLE} from 'features/registration';
import styles from './WorkStatusesInfoDrawer.module.css';

type Props = {
	open: boolean;
	onClose: () => void;
};

export const WorkStatusesInfoDrawer: FC<Props> = ({open, onClose}) => {
	const isMaxSm = useIsMaxSm();
	const sections = getWorkStatusesInfoSections();

	return (
		<Drawer
			open={open}
			onClose={onClose}
			title={WORK_STATUSES_INFO_TITLE}
			showCloseButton
			closeButtonPosition="end"
			bodyClassName={styles.drawerBody}
			variant={isMaxSm ? 'fullscreen' : 'side'}
		>
			<div className={styles.content}>
				{sections.map((section) => (
					<section key={section.id} className={styles.section}>
						<h3 className={styles.sectionTitle}>{section.title}</h3>
						{section.intro ? <p className={styles.intro}>{section.intro}</p> : null}
						{section.example ? <p className={styles.intro}>{section.example}</p> : null}

						{section.taxes ? (
							<div className={styles.subsection}>
								<h4 className={styles.subsectionTitle}>Налоги</h4>
								{section.taxes.caption ? (
									<p className={styles.subsectionText}>{section.taxes.caption}</p>
								) : null}
								{section.taxes.items.length ? (
									<ul className={styles.taxList}>
										{section.taxes.items.map((item) => (
											<li key={`${item.rate}-${item.description}`} className={styles.taxItem}>
												<span className={styles.taxRate}>{item.rate}</span>
												{' – '}
												<span className={styles.taxDescription}>{item.description}</span>
											</li>
										))}
									</ul>
								) : null}
								{section.taxes.note ? <p className={styles.note}>{section.taxes.note}</p> : null}
							</div>
						) : null}

						{section.incomeLimit ? (
							<div className={styles.subsection}>
								<h4 className={styles.subsectionTitle}>Лимит по доходу</h4>
								<p className={styles.subsectionText}>{section.incomeLimit}</p>
							</div>
						) : null}

						{section.audience ? (
							<div className={styles.subsection}>
								<h4 className={styles.subsectionTitle}>Кому подойдёт</h4>
								<p className={styles.subsectionText}>{section.audience}</p>
							</div>
						) : null}
					</section>
				))}
			</div>
		</Drawer>
	);
};
